import HbiImagemHomeClient from '@/api/SistemaDKP/sls-imagem-home.client';

const imagemHomeClient = new HbiImagemHomeClient();
export default {
  namespaced: true,
  state: () => ({
    copyCurrentImagemHome: null,
    currentImagemHome: {
      id: null,
      cod_marca: null,
      caminho: null,
      caminho_catalogo: null,
      ordem_visualizacao: null,
      cor_cabecalho_marca: '#000000', // '#fff
      caminho_img_cabec_marcas: null,
      caminho_img_footer_principal: null,
      caminho_img_footer_secundaria: null,
    },
    imagensHome: [],
    filters: {
      page: 1,
      perPage: 10,
      sortBy: 'ordem_visualizacao',
      sortDesc: null,
    },
    optionsMarcas: [],
    isLoading: false,
  }),
  mutations: {
    setImagensHome(state, imagensHome) {
      state.imagensHome = imagensHome;
    },
    setFilters(state, payload) {
      state.filters = payload;
    },
    setOptionsMarcas(state, payload) {
      state.optionsMarcas = payload;
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    addOfUpdateImagemHome(state, imagemHome) {
      const index = state.imagensHome.findIndex((i) => i.log_img_id === imagemHome.log_img_id);
      if (index === -1) {
        state.imagensHome.push(imagemHome);
      } else {
        state.imagensHome[index] = imagemHome;
      }
    },
    setCurrentImagemHome(state, imagemHome) {
      state.copyCurrentImagemHome = { ...imagemHome };
      state.currentImagemHome = {
        ...imagemHome,
        caminho: null,
        caminho_catalogo: null,
        caminho_img_cabec_marcas: null,
        caminho_img_footer_principal: null,
        caminho_img_footer_secundaria: null,
      };
    },
    deleteImagemHome(state, id) {
      const index = state.imagensHome.findIndex((i) => i.log_img_id === id);
      state.imagensHome.splice(index, 1);
    },
    resetCurrentImagemHome(state) {
      state.currentImagemHome = {
        id: null,
        cod_marca: null,
        caminho: null,
        caminho_catalogo: null,
        ordem_visualizacao: null,
        cor_cabecalho_marca: '#000000', // '#fff
        caminho_img_cabec_marcas: null,
        caminho_img_footer_principal: null,
        caminho_img_footer_secundaria: null,
      };
      state.copyCurrentImagemHome = {
        id: null,
        cod_marca: null,
        caminho: null,
        caminho_catalogo: null,
        ordem_visualizacao: null,
        cor_cabecalho_marca: '#000000', // '#fff
        caminho_img_cabec_marcas: null,
        caminho_img_footer_principal: null,
        caminho_img_footer_secundaria: null,
      };
    },
  },
  getters: {
    getImagensHome(state) {
      return state.imagensHome.sort((a, b) => {
        if (a.ordem_visualizacao > b.ordem_visualizacao) {
          return 1;
        }
        if (a.ordem_visualizacao < b.ordem_visualizacao) {
          return -1;
        }
        return 0;
      });
    },
    getCurrentImagemHome(state) {
      return state.currentImagemHome;
    },
    getCopyCurrentImagemHome(state) {
      return state.copyCurrentImagemHome;
    },
    getFilters(state) {
      return state.filters;
    },
    getIsLoading(state) {
      return state.isLoading;
    },
    getOptionsMarcas(state) {
      state.optionsMarcas.push({ cod_marca: null, des_marca: 'Selecione uma marca' });
      return state.optionsMarcas
        .sort((a, b) => {
          if (a.des_marca === 'Selecione uma marca') {
            return -1;
          }
          if (a.cod_marca > b.cod_marca) {
            return -1;
          }
          if (a.cod_marca < b.cod_marca) {
            return 1;
          }
          return 0;
        })
        .map((m) => ({ text: m.des_marca, value: m.cod_marca }));
    },
    getIsAlteracao(state) {
      return JSON.stringify(state.currentImagemHome) !== JSON.stringify(state.copyCurrentImagemHome);
    },
  },
  actions: {
    async findAll(ctx, queryParams, options) {
      const { data, ...paginations } = await imagemHomeClient.getImagemHome(queryParams);
      ctx.commit('setImagensHome', data);
      ctx.commit('setFilters', {
        ...ctx.getters.getFilters,
        page: paginations.page,
        perPage: paginations.perPage,
      });
      return Promise.resolve({
        data,
        paginations,
      });
    },
  },
};
